export const ILLUSTRATION_MAX_BYTES = 350 * 1024;
export const ILLUSTRATION_DATA_URL_RE = /^data:image\/(webp|jpeg|jpg|png);base64,/i;

export function validateIllustrationDataUrl(dataUrl) {
  if (typeof dataUrl !== "string" || !ILLUSTRATION_DATA_URL_RE.test(dataUrl)) {
    return { ok: false, message: "Format d'illustration invalide." };
  }

  const base64 = dataUrl.split(",")[1] || "";
  const byteLength = Math.ceil((base64.length * 3) / 4);
  if (byteLength > ILLUSTRATION_MAX_BYTES) {
    return {
      ok: false,
      message: `L'illustration est trop volumineuse (max ${Math.round(
        ILLUSTRATION_MAX_BYTES / 1024
      )} Ko).`,
    };
  }

  return { ok: true };
}
